import { render, staticRenderFns } from "./AdvancedMenu.vue?vue&type=template&id=b3743736&"
import script from "./AdvancedMenu.vue?vue&type=script&lang=ts&"
export * from "./AdvancedMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports